import styled from 'styled-components';

export const Container = styled.div`
  padding: 10px 0 30px 0;
`;
export const ContainerText = styled.div`
  text-align: center;
  padding: 10px 0 30px 0;

  p,
  strong {
    font-family: 'Inter', sans-serif;
    font-size: 32px;
  }

  strong {
    font-weight: bold;
  }
`;
export const Content = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 0.5em 1em;
`;

export const ContentQuestions = styled.div`
  margin: 8px 0;
  .BaSe--accordion {
    border-radius: 100px !important;
  }

  .BaSe--accordion-title-container {
    border-top-left-radius: 32px !important;
    border-top-right-radius: 32px !important;
  }

  @media (max-width: 425px) {
    .BaSe--accordion {
      border-radius: 40px !important;
    }
  }
`;

export const ContentDescription = styled.div`
  padding: 12px 0;
  width: 100%;
`;
